<template>
  <el-dialog
    :close-on-click-modal="false"
    title="承包商负责人账号信息"
    :visible.sync="dialogVisible"
    class="small-dialog"
    v-dialogDrag
    @close="closeDialog"
  >
    <el-form :model="form" label-width="150px">
      <el-form-item label="所属承包商：">{{ form.contractorName }}</el-form-item>
      <div id="copyContent">
        <el-form-item label="负责人账号：">{{ form.userName }}</el-form-item>
        <el-form-item label="初始密码：">{{ form.initialPwd }}</el-form-item>
      </div>
      <el-form-item label="初始密码规则：">账号拼音首字母大写+.身份证后四位</el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button size="small" type="primary" @click="copy">复制信息</el-button>
      <el-button size="small" class="iconfont icon-close" @click="closeDialog()">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { ContractorAccountRelationApi } from '@wiz-api/contractor-management'

const contractorAccountRelationApi = new ContractorAccountRelationApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      form: {},
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getDetail()
      }
    },
  },
  methods: {
    async getDetail() {
      const [err, res] = await contractorAccountRelationApi.getContractorLeaderAccountInfo(this.id)
      if (!err) {
        this.form = res
      }
    },
    async copy() {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(
          `负责人账号：${this.form.userName}\n初始密码：${this.form.initialPwd}`
        )
        this.$message.success('复制成功')
      } else if (document.execCommand && document.execCommand('copy')) {
        const copyContent = document.getElementById('copyContent')
        const selection = window.getSelection()
        const range = document.createRange()
        if (selection.rangeCount > 0) selection.removeAllRanges()
        range.selectNode(copyContent)
        selection.addRange(range)
        document.execCommand('copy')
        this.$message.success('复制成功')
      } else {
        this.$message.warning('复制失败，请使用Ctrl+C或右键复制')
      }
    },
    closeDialog(done) {
      this.form = this.$options.data().form
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
  },
}
</script>

<style></style>
